module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1107.8efa2d5b.png";